<template>
  <div >
    <div class="video_appbox show">
     
        <div
                style="display: flex; align-items: center; justify-content: center; margin-bottom: 16px;"
                v-html="iframeContent"
                v-if="iframeContent"
              ></div>
    </div>
   <div class="cloud-home-container">
    <div class="cloud-home-item">
      <div class="cloud-home-item-title">Core Features</div>
      <div class="cloud-home-item-more" @click="moreArticle()">More  <i  style="cursor: pointer;margin-left: 4px;" class="iconfont icon-right"></i></div>
    </div>
    <div class="list">
      <div class="list-item" v-for="item in list" :key="item.title" @click="handleItemClick(item)">
      
          <div>
            <div class="list-item-title"> <img :src="item.png"  style="width: 16px; height:16px;margin-right: 8px;margin-top:3px">{{ item.title }}</div>
            <div class="list-item-description">{{ item.content.docAbstract }}</div>
          </div>
          <div class="list-item-content-more"><i  style="cursor: pointer;margin-left: 4px;" class="iconfont icon-right"></i></div>
        
      </div>
    </div>
    <div class="cloud-home-item" style="margin-top:24px;" v-if="faqList.length > 0">
      <div class="cloud-home-item-title">FAQ</div>
      <div class="cloud-home-item-more"></div>
    </div>
    <div class="list-faq" v-if="faqList.length > 0">
      <div class="list-item-faq" v-for="item in faqList" :key="item.title" @click="handleItemClick(item)">
        <div class="list-item-title-faq"> {{ item.title }}</div>
     
      </div>
    </div>
   </div>
  </div>
</template>
<script></script>
<script>
import NoData from "@/views/noData.vue";
import { getIspcloudhomeCategories, getJSON, articles,getIspcloudhomePng } from "@/utils/query.js";
import { getNowDate } from "@/utils/tool.js";
export default {
  components: { NoData },
  props: {
    id: {},
    title: {},
    isShow: {
      default: true,
    },
  },
  data() {
    return {
      targetOffset: window.innerHeight / 4,
      loadding: false,
      h3list: [],
      imglist: [],
      articleTime: "",
      content: "",
      showArticle: false,
      isshow: "",
      list:[
       
                                            
      ],
      messageHandler: null, // 存储消息处理器引用
      faqList:[],
      videoList:[],
      iframeContent: "",
      pnglist:[],//保存文章一一对应的图片
      firsturl:'https://realenet-1301408934.file.myqcloud.com/helpcenter/'
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.initView();
  
  },
  methods: {
    async initView(){
     await  this.getArticlesPng();
      this.getCate();
    },
    async getArticlesPng(){
      let res = await getIspcloudhomePng(this.id);
      if(res.code == '200'){
        for(let i = 0; i < res.data.directoryJson.length; i++){
          let list = res.data.directoryJson[i].children;
          this.pnglist = list;
        }
      }
    },
    async getCate() {
      let res = await getIspcloudhomeCategories();
      this.List = [];
      this.List2 = [];
      if (res.code == '200') {
        for(let i = 0; i < res.data.directoryJson.length; i++){
          let list = res.data.directoryJson[i].children;
          //对应文章
          for(let j = 0; j < list.length; j++){
            let res = await articles(list[j].id);
            if(res.code == '200'){
              list[j].content = res.data;
            
            }
          }
            if(res.data.directoryJson[i].id == '1755764225015'){
              for(let j = 0; j < list.length; j++){
                list[j].png = this.firsturl+this.pnglist[j].title.toLowerCase()+'.png';
              }
              this.list=[...list]
            } else if(res.data.directoryJson[i].title == 'Video'){
             this.videoList = [...list];
             this.getContent( this.videoList[0].content.content);
            } else {
              this.faqList = [...list]
            
          }
        }
      }

    },
    onAddUrl() {
      this.$nextTick(function() {
        let _aList = this.$refs.preview.$el.querySelectorAll(
          "h1,h2,h3,h4,h5,h6"
        );
        let list = [];
        for (let i = 0; i < _aList.length; i++) {
          let _a = _aList[i];
          console.log(_a);
          let id = _a.getAttribute("data-v-md-line");
          if (!id) continue; // 把不属于导航中的a标签去掉，否则会报错
          _a.id = id; //锚点
          _a.xx = id; //锚点
          list.push(_a);
        }
        this.h3list = list;
        console.log("%O", this.$refs.preview.$el);
      });
    },
    async getContent(contentUrl) {
      debugger
      this.iframeContent = "";
      let json = await getJSON(contentUrl);
      this.content = json ? json : "";
      // 提取第一个 <iframe ...>...</iframe> 字符串
      const iframeMatch = this.content.match(/<iframe[\s\S]*?<\/iframe>/i);
      let iframeContent = iframeMatch ? iframeMatch[0] : "";


      this.iframeContent = iframeContent;
      // 移除所有 <iframe ...></iframe> 标签（包括YouTube等嵌入视频）
      this.content = this.content.replace(/<iframe[\s\S]*?<\/iframe>/gi, "");
      this.loadding = false;
    },
    moreArticle(){
      this.$emit('moreArticle');
    },
    handleItemClick(item){
      this.$emit('handleItemClick',item);
    },
    sentzhugePoint(articleid) {
      let articleTitle = this.title || this.articleTitle;
      this.zhugePoint("macc-help-文档中心-文章统计", {
        userid: this.GLOBAL.userid, //用户id
        articleid, //文章id
        articleTitle, //文章标题
      });
      console.log("macc-help-文档中心-文章统计", articleTitle);
    },
  },
};
</script>
<style lang="scss" scoped>

.cloud-home-container{
  width: 100%;
}

.cloud-home-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.cloud-home-item-title{
  font-size:16px;
  font-weight: 500;
  color: #363A42;
}
.cloud-home-item-more{
  font-size: 14px;
  color: #565B66;
  &:hover{
    color: #1B6DFA ;
  }
  cursor: pointer;
}
.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
 
}
.list-item-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-item {
  cursor: pointer;
    border-radius: 8px;
    padding:12px;
    display: flex;
  justify-content: space-between;
  align-items: center;
    &:hover{
      background-color: #F5F7FA;
      .list-item-content-more {
        opacity: 1;
      }
    }
  }
  .list-item-title{
    font-size: 14px;
    font-weight: 600;
    color: #30343D;
    display: flex;
    margin-bottom: 6px;
  }
  .list-item-description{
    font-size: 12px;
    color: #797E8A;
  }
  .list-item-content-more {
    opacity: 0;
    transition: opacity 0.2s ease;
    color: #565B66;
    font-size: 14px;
  }

.list-faq{
  display: flex;
  flex-direction: column;

}
.list-item-faq {
  cursor: pointer;
  font-size: 14px;
  color: #30343D;
  display: flex;
  margin-bottom: 12px;

  &::before {
    content: '•';
    font-size: 16px;
    font-weight: 600;
    color: #30343D;
    margin-right: 4px;
    margin-top: -3px;
  }
 
}
.list-item-faq:hover {
  color: #1B6DFA;
}
.list-item-faq:hover::before {
  color: #1B6DFA;
}

</style>
